import React, {useEffect, useState, useContext} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import Select from 'react-select';
import { resourcesAttendances } from '../../../helpers/backend_helper';
import {Alert,ConfirmAsistencia} from '../../../helpers/alerts/alertHelper';

const AttendanceModal = ({modal,setModal,items, setItems, setItem,item,authUser,filters,setFilters}) => {
	const [ errors, setErrors ] = useState([]);
	const [ loading, setLoading ] = useState(false);
	const handleClose = () => {
		setModal({...modal,show:false});
    }

    const changeStatus = (status) => {
    	let data = {
			date:modal.date,
			id:modal.item.id,
			attendance:status
	    }
    	ConfirmAsistencia(async confirmed => {
            if (!confirmed) { return; }
            resourcesAttendances('post',data).then(response => {
    			setFilters({...filters,week:filters.week})
    			setModal({...modal,show:false});
    		})
        });
    }

    return (
		<div>
	        <Modal isOpen={modal.show}>
				<ModalHeader className="bg-primary">Asistencia {modal.day} {modal.date}</ModalHeader>
				<ModalBody>
					<div className="row">
						<div className="col-sm-2">
						</div>
						<div className="col-sm-5">
							<button onClick={() => changeStatus(true)} className="btn btn-primary " title='Asistencia'>
								<i className="fa fa-check-circle fa-1x"></i> Asistencia
							</button> 
						</div>
						<div className="col-sm-5">
							<button onClick={() => changeStatus(false)} className="btn btn-danger " title='Asistencia'>
								<i className="fa fa-times-circle fa-1x"></i> No asistió
							</button> 
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={handleClose}>Cancelar</Button>
				</ModalFooter>
	        </Modal>
		</div>
	);
}

export default AttendanceModal;